import {Partner} from './partner';

export class RestrictedIata {

  constructor(public id: number = 0,
              public iataNumber: string = null,
              public isIncluded: boolean = true,
              public iataPartner: Partner = new Partner(),
              public createdBy: string = null,
              public createdDate: Date = null,
              public updatedBy: string = null,
              public updatedDate: Date = null) { }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/restricted-iata.ts